<template>
    <div class="SamplePeriodSelector">
        <APeriodSelector 
            ref="PeriodSelector"
            @change="handlechange"
        ></APeriodSelector>
        <div>
            시작: {{ result.startDate ? result.startDate : '' }}
            종료: {{ result.endDate ? result.endDate : '' }}
        </div>
        <el-button @click="handleClickNext">Next</el-button>
    </div>
</template>

<script>

export default {  
    name: 'SamplePeriodSelector',
    data() {
        return {
            value: '1w',
            result: {}
        }
    },
    methods: {
        handleChange(value) {
            this.value = value;
        },
        handlechange(value) {
            this.result = value;
        },
        handleClickNext() {
            if (!this.result.valid) {
                this.util.notify_error(this, "TEST", "Can't execute next level.")
            } else {
                this.util.notify(this, "s", "TEST", "Can execute next level.")
            }
        }
    }
};
</script>
